<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
				<el-form-item label="分红比例" prop="fh_scale" style="width: 450px;">
				   <div class="w-100 flex align-center">
						<el-input v-model="form.fh_scale" type="number" placeholder="请输入分红比例" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					</div>
				</el-form-item>
				<el-form-item>
				   <el-button type="primary" size="small" @click="submit" style="width: 250px;">确定</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: '',
				autoRequest: false,
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					id:this.VueCookies.get('store_id'),
					fh_scale:'',
				},
				rules:{
				},
				info:{},
			}
		},
		mounted() {
			this.getAdminInfo()
		},
		methods:{
			getAdminInfo(){
				this.axios.get('/manage/store/detail?id='+this.VueCookies.get('store_id')).then(res=>{
					if(res.status){
						this.info = res.data
						this.form.fh_scale = res.data.fh_scale
					}
				})
			},
			reset() {
			  this.form = {
				  id:this.VueCookies.get('store_id'),
				  fh_scale:'',
			  }
			  this.resetForm('form')
			},
			submit(){
				this.$refs.form.validate(valid => {
				  if (valid) {
					  this.axios.post('/manage/store/toEdit', this.form).then(res => {
					    if (res.status) {
					      this.$message.success('修改成功')
					    } else {
					      this.$message.error(res.msg)
					    }
					  })
				  }
				})
			},
		}
	}
</script>
<style>
</style>